import { array, bool, func, number, string } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { isEmpty } from 'ravenjs/utils/lodash';
import Typography from 'ravenjs/lib/Typography';
import { getThemeProps } from 'ravenjs/utils/theme';

import { ArrowDownIcon, ArrowUpIcon, GridIcon } from 'components/Icons';
import { DEFAULT_COLORS } from 'constants/colors';

const HeaderStyled = styled.div`
    align-items: center;
    background: ${DEFAULT_COLORS.WHITE};
    border: solid 1px ${DEFAULT_COLORS.PLACEHOLDER};
    border-radius: 2px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    height: 2.375rem;
    padding: 0 0.8125rem;
    width: 100%;
`;

const IndicatorContainer = styled.div`
    padding: 0;
`;

const SelectedNumber = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 2.5rem;
    width: 1rem;
    min-width: auto;
    height: 1rem;
    font-size: 0.75rem;
    line-height: 1rem;
    padding: 0;
    background-color: ${({ theme }) =>
        getThemeProps('palette.primary.gradientColor', DEFAULT_COLORS.BLUE, {
            theme,
        })};
    color: ${({ theme }) =>
        getThemeProps('palette.primary.text', DEFAULT_COLORS.BLACK, {
            theme,
        })};
    border-radius: 100%;
    top: 50%;
    transform: translateY(-50%);
`;

const TooltipFilterWrapper = styled.div`
    position: relative;
    width: 100%;
`;

const GridIconContainer = styled.div`
    margin: 0.5rem -0.156rem 0 0;
`;

const HeaderComponent = ({
    count,
    currentSelected,
    excludeSelected,
    isOpen,
    onHeaderClick,
    title,
    useAltIcon,
    checkAllOptions,
}) => {
    const getCount = () => {
        let totalCount = 0;

        if (typeof count === 'number') {
            totalCount = count;
        } else if (
            checkAllOptions &&
            !isEmpty(currentSelected) &&
            currentSelected.join().indexOf('All') !== -1
        ) {
            totalCount = currentSelected.length - 1;
        } else if (!isEmpty(currentSelected) && currentSelected.join().indexOf('All') !== -1) {
            totalCount = 1;
        } else {
            totalCount = !isEmpty(currentSelected) && currentSelected.length;
            if (!isEmpty(excludeSelected)) {
                const partialCount = currentSelected.filter(
                    item => excludeSelected.indexOf(item) !== -1
                );
                totalCount -= partialCount.length;
            }
        }

        return totalCount;
    };

    const handleHeaderClick = () => {
        onHeaderClick && onHeaderClick();
    };

    return (
        <TooltipFilterWrapper>
            <HeaderStyled onClick={handleHeaderClick}>
                <Typography
                    fontWeight="500"
                    color={`${DEFAULT_COLORS.BLACK} !important`}
                    type="documentFilter"
                >
                    {title}
                </Typography>
                <SelectedNumber>{getCount()}</SelectedNumber>
                <IndicatorContainer>
                    {useAltIcon && (
                        <GridIconContainer>
                            <GridIcon />
                        </GridIconContainer>
                    )}
                    {!useAltIcon && (isOpen ? <ArrowUpIcon /> : <ArrowDownIcon />)}
                </IndicatorContainer>
            </HeaderStyled>
        </TooltipFilterWrapper>
    );
};

HeaderComponent.propTypes = {
    checkAllOptions: bool,
    count: number,
    currentSelected: array,
    excludeSelected: array,
    isOpen: bool,
    onHeaderClick: func,
    title: string,
    useAltIcon: bool,
};

HeaderComponent.defaultProps = {
    checkAllOptions: false,
    count: null,
    currentSelected: [],
    excludeSelected: [],
    isOpen: false,
    onHeaderClick: null,
    title: null,
    useAltIcon: false,
};

export default HeaderComponent;
